import React from 'react';
import { useTranslation } from 'react-i18next';
import './style.css';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('i18nextLng', lng);
  };

  const normalizeLang = (lng) => (lng || 'en').split('-')[0];
  const currentLang = normalizeLang(i18n.language);

  return (
    <div className="language-switcher">
      <button
        className={`lang-btn ${currentLang === 'ko' ? 'active' : ''}`}
        onClick={() => changeLanguage('ko')}
        title="한국어"
      >
        🇰🇷
      </button>
      <button
        className={`lang-btn ${currentLang === 'en' ? 'active' : ''}`}
        onClick={() => changeLanguage('en')}
        title="English"
      >
        🇺🇸
      </button>
    </div>
  );
};
